<template>
    <v-container fluid>

        <v-row align="center"
               justify="center">
            <v-col cols="12"
                   md="8">
                <h1>
                    Home
                </h1>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  metaInfo() {
    this.$store.commit('setTitle', 'Home');
    return {
      title: this.$store.getters.title,
    }
  },
    data() {
        return {
            formularies: [],
        }
    },
    computed: {
        ...mapGetters([
            'user',
        ])
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
        },
    }
}
</script>
